import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import OrderNotFoundSection from '../../../paymentJourney/OrderNotFoundSection/OrderNotFoundSection';
import BookingClosedSection from '../../../paymentJourney/BookingClosedSection/BookingClosedSection';

export function OrderNotFoundView(props) {
  const {
    t,
    siteHeader: {
      data: { booking, title: dataTitle } = {},
      meta: { title: metaTitle } = {},
    } = {},
  } = props;
  const title = metaTitle || dataTitle;
  const helmetTitle = title
    ? `${t('event.purchase.order-not-found')} | ${title}`
    : t('event.purchase.order-not-found');

  return (
    <SiteLayout
      helmet={{ title: helmetTitle }}
      style={{ backgroundColor: '#fff' }}
      footerUpperHidden
    >
      {booking ? <OrderNotFoundSection /> : <BookingClosedSection />}
    </SiteLayout>
  );
}

OrderNotFoundView.propTypes = {
  siteHeader: PropTypes.shape({
    data: PropTypes.shape({
      booking: PropTypes.bool,
      title: PropTypes.string,
    }),
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
  };
}

export default withTranslation()(connect(mapStateToProps)(OrderNotFoundView));
